import { debounce } from "lodash-es";
export var inViewPort = function (callback, element) {
    var checkInView = debounce(function () {
        var counterElementPos = element.getBoundingClientRect();
        if (counterElementPos.top >= 0 &&
            counterElementPos.top <= (window.innerHeight || document.documentElement.clientHeight)) {
            callback();
        }
    }, 100);
    ['load', 'scroll'].forEach(function (eventName) { return window.addEventListener(eventName, checkInView); });
};
